<template>
  <el-dialog class="el-dialogs" :title="title" :fullscreen="true" :close-on-click-modal="false"
             :visible.sync="visible">
    <el-row :gutter="10">
      <el-col :span="16">
        <el-card class="heightSet" v-loading="loading">
          <div class="knowledge" ref="knowledgeGraph"></div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="heightSet">
          <div class="minTitle">知识图谱基本信息</div>
          <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
                   label-width="130px">
            <el-form-item label="知识图谱名称：" prop="knowledgeName">
              <div>{{ searchForm.knowledgeName }}</div>
            </el-form-item>
            <el-form-item label="关联元数据模板：" label-width="130px" prop="metaName">
              <div>{{ searchForm.metaName }}</div>
            </el-form-item>
            <el-form-item label="状态：" prop="knowledgeState">
              <el-switch
                  disabled
                  v-model="searchForm.knowledgeState"
                  active-value="1"
                  inactive-value="0">
              </el-switch>
            </el-form-item>
            <el-form-item label="描述：" prop="knowledgeDescribe">
              <div ref="describeHeight" :class="[describeOpen ? 'openHeight' : 'describeHeight']">
                {{ searchForm.knowledgeDescribe }}
              </div>
              <div v-show="fizeShow" class="Scale text_center">
                                <span v-show="describeOpen" @click="describeOpen = !describeOpen">收起<i
                                    class="el-icon-arrow-up"></i></span>
                <span v-show="!describeOpen" @click="describeOpen = !describeOpen">展开<i
                    class="el-icon-arrow-down"></i></span>
              </div>
            </el-form-item>
            <el-form-item label="最新修改时间：" prop="updateDate">
              <div>{{ searchForm.updateDate }}</div>
            </el-form-item>
            <el-form-item label="创建时间：" prop="createDate">
              <div>{{ searchForm.createDate }}</div>
            </el-form-item>
            <div class="minTitle" style="margin-top: 15px">节点信息</div>
            <el-select v-model="keyId" size="small" style="width: 100%" @change="getNodeDetail" filterable
                       placeholder="请输入节点名称搜索">
              <el-option
                  v-for="item in allNode.filter(item=>{return item.category == '节点'})"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
              </el-option>
            </el-select>
            <el-form-item label="节点名称：">
              <div>{{ nodeDetail.knowledgeName }}</div>
            </el-form-item>
            <el-form-item label="来源：">
              <div>{{ nodeDetail.knowledgeSource }}</div>
            </el-form-item>
            <el-form-item label="父节点：">
              <div>{{ nodeDetail.parentName }}</div>
            </el-form-item>
            <el-form-item label="关联元数据：">
              <div>{{ nodeDetail.metadataName }}</div>
            </el-form-item>
            <el-form-item label="状态：">
              <el-switch
                  disabled
                  v-model="nodeDetail.graphNodeState"
                  active-value="1"
                  inactive-value="0">
              </el-switch>
            </el-form-item>
            <el-form-item label="备注：">
              <div>{{ nodeDetail.remark }}</div>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
    <div slot="footer">
      <el-button size="small" @click="visible = false">返回</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "detailChart",
  data() {
    return {
      title: '知识图谱详情',
      visible: false,
      searchForm: {
        id: '',
        knowledgeName: '',
        metaName: '',
        knowledgeState: '0',
        knowledgeDescribe: '',
        updateDate: '',
        createDate: '',
      },
      rules: {
        knowledgeName: [
          {required: true, message: '请输入知识图谱名称', trigger: 'blur'}
        ],
      },
      knowledgeGraph: null,
      describeOpen: false,
      fizeShow: false,

      selectData: {},

      keyId: '',
      allNode: [],
      nodeDetail: {},
      loading: false,
    }
  },

  methods: {
    init(row) {
      if (this.knowledgeGraph) {
        this.knowledgeGraph.off('click');
      }
      this.visible = true
      this.keyId = ''
      this.nodeDetail = {}
      this.selectData = row
      //监听浏览器变化
      window.onresize = () => {
        this.knowledgeGraph.resize()
      }
      this.getDetail()
    },

    //获取详情
    getDetail() {
      this.loading = true
      this.$axios(this.api.academic.knowledgegraphGetByIdGeneral + this.selectData.id).then(data => {
        if (data && data.code == 200) {
          this.allNode = data.data
          this.allNode.forEach(item => {
            this.$set(item, 'draggable', true)
            if (item.category === '') {
              this.$set(item, 'symbolSize', 40)
              this.$delete(item, 'category')
            } else {
              this.$set(item, 'symbolSize', 20)
            }
          })
          this.setGraph(this.allNode, data.links)
          this.loading = false
        }
      })

      this.searchForm = this.selectData
      this.$nextTick(() => {
        this.setDescribeHeight()
      })
    },

    //知识图谱加载
    setGraph(allNode, relationship) {
      let that = this
      this.knowledgeGraph = this.$echarts.init(this.$refs.knowledgeGraph)
      let option = {
        backgroundColor: that.$echarts.graphic.RadialGradient(0.3, 0.3, 0.8, [{
          offset: 0,
          color: '#f7f8fa'
        }, {
          offset: 1,
          color: '#cdd0d5'
        }]),
        //鼠标悬停提示
        tooltip: {
          formatter: function (params) {
            let res
            if (params.data.name) {
              res = params.data.name + ' - ' + params.data.metadata;
            } else {
              // res = params.data.target + ' - ' + params.data.source;
            }
            return res;
          }
        },
        //图例
        legend: [{
          show: false,
          tooltip: {
            show: true
          },
          selectedMode: 'false',
          bottom: 20,
          data: ['节点', '资源']
        }],
        animationDuration: 3000,
        animationEasingUpdate: 'quinticInOut',
        series: [
          {
            name: '节点名称',
            type: 'graph',
            layout: 'force',
            force: {
              repulsion: 85,
              gravity: 0.1
            },
            //所有节点
            data: allNode,

            //节点间的关系数据
            links: relationship,

            //如果节点有分类的话可以指定每个类目的样式,所有该类目都用该样式
            categories: [
              {
                'name': '节点'
              },
              {
                'name': '资源'
              },
            ],
            focusNodeAdjacency: true,
            roam: true, //是否开启鼠标缩放和平移漫游
            label: { //标签
              normal: {
                show: true,
                position: 'top',
              }
            },
            lineStyle: { //关系边的线条样式
              normal: {
                color: 'source',
                curveness: 0,
                type: "solid"
              }
            },

          }]
      }
      this.knowledgeGraph.on('click', (params) => {
        this.clickParams(params)
      });
      this.knowledgeGraph.on('mouseup', function (params) {
        var option = that.knowledgeGraph.getOption();
        option.series[0].data[params.dataIndex].x = params.event.offsetX;
        option.series[0].data[params.dataIndex].y = params.event.offsetY;
        option.series[0].data[params.dataIndex].fixed = true;
        that.knowledgeGraph.setOption(option, true);
      });
      this.knowledgeGraph.setOption(option, true)
    },

    getNodeDetail() {
      this.$axios(this.api.academic.knowledgegraphnoeGetParentNameById + this.keyId).then(data => {
        if (data && data.status) {
          this.nodeDetail = data.data
        }
      })
    },

    clickParams(params) {
      // if (params.componentType === 'markPoint') {
      //     // 点击到了 markPoint 上
      //     if (params.seriesIndex === 5) {
      //         // 点击到了 index 为 5 的 series 的 markPoint 上。
      //     }
      // } else
      if (params.componentType === 'series') {
        if (params.seriesType === 'graph') {
          if (params.dataType === 'edge') {
            // 点击到了 graph 的 edge（边）上。
          } else {
            // 点击到了 graph 的 node（节点）上。
            if (params.data.category != '节点') {
              this.$message.warning('您点击的是知识图谱名称')
              return
            }
            this.keyId = params.data.value
            this.getNodeDetail()
          }
        }
      }
    },

    //判断文字是否超出范围
    setDescribeHeight() {
      let scrollHeight = this.$refs.describeHeight.scrollHeight
      let clientHeight = this.$refs.describeHeight.clientHeight
      if (scrollHeight > clientHeight) {
        //文字超出3行
        this.fizeShow = true
      }
    },
  },
}
</script>

<style scoped>
.heightSet {
  height: calc(100vh - 100px) !important;
  overflow-y: auto;
}

.knowledge {
  height: calc(100vh - 150px)
}

.describeHeight {
  height: 100px;
  overflow: hidden;
}

.openHeight {
  height: auto;
}

.Scale {
  font-size: 12px;
  color: #76838f;

  span {
    cursor: pointer;

    i {
      padding-left: 5px;
    }

  }
}

.minTitle {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 10px;
}
</style>
